<!-- 导流活动 -->
<template>
<div class='diversion'>
  <Dvideo
    :url='url'
    :image='image'
    ref="media"
    :started='started'
    :listData='listData'
    :isShowMorning='isShowMorning'
    :name='name'
    @changeBool='changeBool'
  />
  <List
    v-if="collect"
    :listData='listData'
    :mediaData='mediaData'
    :isShowMorning='isShowMorning'
    @handleSelectedPlay='handleSelectedPlay'
    @getSchedule='getSchedule'
  />
  <Collect
    v-else
    :listData='listData'
    @handleSelectedPlay='handleSelectedPlay'
    @changeCollect='changeCollect'
  />
  <Footer
    @changeCollect='changeCollect'
  />
</div>
</template>

<script>
import Dvideo from './components/video'
import List from './components/list'
import Footer from './components/footer'
import Collect from './components/collect'
import api from '@edu-fe/api'
export default {
  components: {
    Dvideo,
    List,
    Collect,
    Footer
  },
  data() {
    return {
      image:'', // 视频图片
      url:'', // 媒体地址
      listData: [], // 列表数据
      id: '', // chapterId
      started: false,
      mediaData: '',
      collect: true,
      name: '',
      isShowMorning:true,
      bool: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    changeBool(bool) {
      this.bool = bool
    },
    changeCollect() {
      this.collect = !this.collect
      // 播放
      this.bool && this.handleSelectedPlay()
      // this.$refs.media.$refs.video.play()
    },
    // 获取列表数据
    async getSchedule() {
      const sourseId = this.$route.query.sourseId || '1aa95b0ec90b11e6aed8fa163e422c00'
      const { data } = await api.diversion.getSchedule(sourseId)()
      if(data.msg = 'success') {
        this.listData = this.processListData(data.chapterList)
        this.isShowMorning ?  this.name = data.chapterList[1].name : this.name = data.chapterList[0].name
        this.isShowMorning ? this.id = data.chapterList[1].id : this.id = data.chapterList[0].id
      }
    },
    // 获取视频数据
    async getMedia() {
      const data  = await api.diversion.getMediaData({
        chapterId: this.id
      })
      if(data.msg = 'success') {
        this.url = data.data.mediaUrl
        this.image = data.data.chapterImage
        this.mediaData = data.data
      }
    },
    // 播放
    handleSelectedPlay(id, name) {
      // 正在播放的id及课程名
      if(id) this.id = id
      if(name) this.name = name
      this.initSelected()
      this.getMedia()
      // 播放视频
      this.started = true
      this.$refs.media.handlePlay()
    },
    initSelected() {
      this.listData.map((ele,index) => {
        Vue.set(this.listData[index], 'ischeck', false)
        if(ele.id === this.id) {
          Vue.set(this.listData[index], 'ischeck', true)
        }
      })
    },
    // 过滤
    processListData (dataSource) {
      if (dataSource.length) {
        dataSource.forEach((item, index)=> {
          if(index === 0) {
            // 是否显示明日更新
            if(new Date().getTime() < item.publishDate) {
              item.filteredDate = '明日更新'
            }else{
              item.filteredDate = '今日更新'
              this.isShowMorning = false
            }
          }
          if(index === 1 && this.isShowMorning) {
            item.filteredDate = '今日更新'
          }
          // 格式化出月、日
          item.filteredPublishDateMonth = moment(item.publishDate).format('MM')
          item.filteredPublishDateDay = moment(item.publishDate).format('DD')
        })
      }
      return dataSource
    },
  },
  created() {
    document.title = 'WPS小技巧'
  },
  async mounted() {
    await this.getSchedule()
    await this.getMedia()
  },
}
</script>
<style lang='scss' scoped>
  @charset "UTF-8";

  @import "../../style/main";
.diversion {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
